exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 640px) {\n.widget-group {\n    margin-left: -15px;\n    margin-right: -15px;\n    border-radius: 0;\n}\n}\n.widget-group-stretched .widget-content {\n  padding-bottom: 50px;\n}\n.widget-group-stretched .widget-footer {\n  position: absolute;\n  bottom: 1.25rem;\n  left: 1.25rem;\n  right: 1.25rem;\n}\n.widget-group .badge.filter-readonly {\n  opacity: 0.8;\n}\n.widget-group .badge .fa-pencil {\n  display: none;\n}\n.widget-group .badge:hover .fa-pencil {\n  display: inline-block;\n}", ""]);

// exports
